module.exports = __webpack_public_path__ + "static/media/style.5315f187.scss";


//////////////////
// WEBPACK FOOTER
// ./src/views/pages/style.scss
// module id = 86
// module chunks = 0